// libraries
import { ReactNode } from 'react';

// assets
import { IconHabiPricing } from '@assets/icons';

interface LoginHeaderProps {
  subtitle?: ReactNode;
}

export const LoginHeader = ({ subtitle }: LoginHeaderProps) => {
  return (
    <>
      <div className="d-flex justify-content-center mb-5">
        <IconHabiPricing />
      </div>
      <div className="title">Inteligencia de Mercados</div>
      {subtitle && (
        <div className="title">{subtitle}</div>
      )}
    </>
  );
};
